import React, { useState } from 'react'
import { formatDateForLabelPDF, formatDilution } from '../../utils/format.utils'
import api from '../../middleware/api'
import downloadPDF from '../../utils/pdf.utils'
import { Check, DownloadIcon, Loader, Pencil, X } from 'lucide-react'

const TooltipLabelPDF = ({ capsule }) => {
    const [isLoading, setIsLoading] = useState(false)
    const [isEditMode, setIsEditMode] = useState(false)
    const [editedCustomer, setEditedCustomer] = useState(capsule.customer || '')
    const [editedCapsuleName, setEditedCapsuleName] = useState(capsule.capsule_name || '')
    const [savedCustomer, setSavedCustomer] = useState(capsule.customer || '')
    const [savedCapsuleName, setSavedCapsuleName] = useState(capsule.capsule_name || '')

    // Gérer le téléchargement du PDF
    const handleDownloadPDF = async () => {
        try {
            setIsLoading(true)

            // Utiliser les valeurs sauvegardées ou les valeurs originales
            const customerName = savedCustomer || capsule.customer
            const capsuleName = savedCapsuleName || capsule.capsule_name

            // Préparer les données pour le PDF
            const payload = {
                customer_name: customerName,
                capsule_name: capsuleName,
                dilutions: capsule.dilutions,
                capsuleId: capsule.id
            }

            // Appeler l'API pour générer le PDF
            const response = await api.post(`/pdf`, payload)

            // Télécharger le PDF si la réponse est réussie
            if (response.status === 200) {
                downloadPDF(response.data, `${customerName} - ${capsuleName}`)
            }
        } catch (error) {
            console.error('Erreur lors du téléchargement du PDF', error)
        } finally {
            setIsLoading(false)
        }
    }

    // Gérer le mode édition
    const handleEditMode = () => {
        setIsEditMode(true)
        setEditedCustomer(savedCustomer || capsule.customer || '')
        setEditedCapsuleName(savedCapsuleName || capsule.capsule_name || '')
    }

    // Sauvegarder les modifications
    const handleSaveEdit = () => {
        setSavedCustomer(editedCustomer)
        setSavedCapsuleName(editedCapsuleName)
        setIsEditMode(false)
    }

    // Annuler les modifications
    const handleCancelEdit = () => {
        setIsEditMode(false)
        setEditedCustomer(savedCustomer || capsule.customer || '')
        setEditedCapsuleName(savedCapsuleName || capsule.capsule_name || '')
    }

    // Utiliser les valeurs appropriées pour l'affichage
    const displayCustomer = isEditMode ? editedCustomer : (savedCustomer || capsule.customer)
    const displayCapsuleName = isEditMode ? editedCapsuleName : (savedCapsuleName || capsule.capsule_name)

    // Calculer les tailles de police en fonction de la longueur du texte (similaire au backend)




    const sortedDilutions = capsule.dilutions.sort((a, b) => {
        const order = ['A', 'R', 'S', 'E'];
        return order.indexOf(a) - order.indexOf(b);
    });

    console.log(capsule)

    return (
        <div className="flex flex-col space-y-4 bg-base-100">
            <h3 className="text-sm font-bold">Prévisualisation de l'étiquette</h3>

            {/* Mode édition - champs de saisie */}
            {isEditMode && (
                <div className="space-y-2 p-3 bg-base-200 rounded-lg">
                    <div>
                        <label className="label">
                            <span className="label-text text-xs">Nom du client</span>
                        </label>
                        <input
                            type="text"
                            className="input input-sm input-bordered w-full"
                            value={editedCustomer}
                            onChange={(e) => setEditedCustomer(e.target.value)}
                            placeholder="Nom du client"
                        />
                    </div>
                    <div>
                        <label className="label">
                            <span className="label-text text-xs">Nom de la capsule</span>
                        </label>
                        <input
                            type="text"
                            className="input input-sm input-bordered w-full"
                            value={editedCapsuleName}
                            onChange={(e) => setEditedCapsuleName(e.target.value)}
                            placeholder="Nom de la capsule"
                        />
                    </div>
                </div>
            )}

            {/* Prévisualisation de l'étiquette - version agrandie */}
            <div className="relative bg-white border border-gray-300 shadow-sm rounded-md overflow-hidden mx-auto"
                style={{
                    width: '220px',  // 22mm * 10 pour la prévisualisation
                    height: '60px',  // 6mm * 10 pour la prévisualisation
                    padding: '3px',
                    boxSizing: 'border-box'
                }}>
                <div className="flex flex-col h-full justify-between ml-[50px]" style={{ lineHeight: 'normal' }}>
                    {/* Nom du client */}
                    <p className="overflow-hidden text-ellipsis whitespace-nowrap"
                        style={{
                            fontSize: '12x',
                            fontWeight: 'bold',
                            textTransform: 'uppercase',
                            lineHeight: '1',

                        }}>
                        {displayCustomer}
                    </p>

                    {/* Nom de la capsule */}
                    <div className="text-center font-bold overflow-hidden text-ellipsis whitespace-nowrap"
                        style={{
                            fontSize: "12px",
                            lineHeight: '2',
                            margin: '0',
                            width: '100%',
                        }}>
                        <span className='font-bold'>{displayCapsuleName} - #{capsule.id}</span>
                    </div>

                    {/* Pied de page */}
                    <div className="flex justify-between"
                        style={{ fontSize: '12px', marginTop: 'auto' }}>
                        <span className='font-bold'>{capsule.creation_date ? formatDateForLabelPDF(capsule.creation_date) : ''}</span>
                        <span className='font-bold'>{sortedDilutions.join('.')}</span>
                    </div>
                </div>
            </div>

            {/* Boutons d'action */}
            {!isEditMode ? (
                <div className="flex gap-2">
                    <button
                        className="btn btn-outline btn-sm flex-1"
                        onClick={handleEditMode}
                    >
                        <Pencil className='w-4 h-4' />
                        <span className='text-xs'>Modifier</span>
                    </button>
                    <button
                        className="btn btn-primary btn-sm flex-1"
                        onClick={handleDownloadPDF}
                        disabled={isLoading}
                    >
                        {
                            isLoading ? (
                                <>
                                    <Loader className='w-4 h-4 animate-spin' />
                                    <span className='text-xs'>Génération...</span>
                                </>
                            ) : (
                                <>
                                    <DownloadIcon className='w-4 h-4' />
                                    <span className='text-xs'>Télécharger</span>
                                </>
                            )
                        }

                    </button>
                </div>
            ) : (
                <div className="flex gap-2">
                    <button
                        className="btn btn-primary btn-sm flex-1"
                        onClick={handleSaveEdit}
                    >
                        <Check className='w-4 h-4' />
                        <span className='text-xs'>Enregistrer</span>
                    </button>
                    <button
                        className="btn btn-error btn-sm flex-1"
                        onClick={handleCancelEdit}
                    >
                        <X className='w-4 h-4' />
                        <span className='text-xs'>Annuler</span>
                    </button>
                </div>
            )}
        </div>
    )
}

export default TooltipLabelPDF
